<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="w-1/4 flex">
        <InputWrapper :label="'Año'" content="input" class="mr-2">
            <InputText type="year" v-model.number="year" @input="loadData"/>
        </InputWrapper>
    </div>
    <div class="flex justify-between mb-4">
      <div class="max-w-sm space-y-1">
        <p class="font-semibold text-primario text-lg tracking-wide">
          CONTROL GENERAL DE PRODUCCIÓN
        </p>
        <p class="font-semibold text-secundario text-xs tracking-wide">
          Oficinas centrales. Burela. Lugo (Galicia)
        </p>
        <p class="font-semibold text-secundario text-xs tracking-wide">
          Delegación Santiago de Compostela (O Milladoiro).
          <br>A Coruña (Galicia) - ESPAÑA
        </p>
      </div>
      <table class="border-collapse">
        <thead>
          <tr>
            <th />
            <th />
            <th />
            <th class="text-blue-100 font-semibold border-2 border-primario text-xs bg-blue-500 text-center" colspan="2">
              TOTAL UDS AÑO {{ year }}
            </th>
          </tr>
        </thead>
        <tbody class="border-2 border-primario border-collapse text-xs">
          <tr>
            <td>En gestión</td>
            <td class="w-16 bg-secundario border-2 border-primario" />
            <td class="w-16 bg-primario border-2 border-primario" />
            <td class="text-primario font-semibold border-2 border-primario px-2">
              Gran total
              <br>(Sin cancelar)
            </td>
            <td class="text-primario font-semibold border-2 border-primario px-2 text-right">
              {{ total }}
            </td>
          </tr>
          <tr>
            <td>Entregado y facturado</td>
            <td class="w-16 bg-blue-500 border-2 border-primario" />
            <td class="w-16 bg-blue-600 border-2 border-primario" />
            <td class="text-blue-600 font-semibold border-2 border-primario px-2">
              Entregadas
            </td>
            <td class="text-blue-600 font-semibold border-2 border-primario px-2 text-right">
              {{ completadas }}
            </td>
          </tr>
          <tr>
            <td>Cancelado/Devolución</td>
            <td class="w-16 bg-rojo border-2 border-primario" />
            <td class="w-16 bg-rojo-oscuro border-2 border-primario" />
            <td class="text-rojo-oscuro font-semibold border-2 border-primario px-2">
              Canceladas
            </td>
            <td class="text-rojo-oscuro font-semibold border-2 border-primario px-2 text-right">
              {{ canceladas }}
            </td>
          </tr>
        </tbody>
        <tfoot class="text-xs">
          <tr>
            <td />
            <td />
            <td />
            <td class="text-verde-oscuro font-semibold border-2 border-primario px-2">
              PTES de entregar
            </td>
            <td class="text-verde-oscuro font-semibold border-2 border-primario px-2 text-right">
              {{ productionsPending }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <table class="border-collapse">
      <thead>
        <tr class="text-center font-semibold text-sm text-gray-800">
          <th
            class="px-1 border-2 border-primario"
            v-for="(header, index) in headers"
            :key="`header_${index}`"
          >
            <span>{{ header.name|aux(header) }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rowCell, rowIndex) in data" :key="'row_' + rowIndex" class="text-xs hover:bg-gray-200">
          <td v-for="(headerCell, headerIndex) in headers" :key="'cell_' + rowIndex + '_' + headerIndex" class="p-1 text-center border-2 border-primario">
            <span v-if="headerCell.type == 'datetime'">{{ rowCell[headerIndex] | datetime }}</span>
            <span v-else>{{ rowCell[headerIndex] }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import InputText from "@/components/core-ui/InputText";
export default {
  name: "ProductionControl",
    components: {InputText},
    data() {
    return {
      headers: {
        reference: "Referencia",
        color: "Color",
        client: "Cliente",
        section: "Sección",
        product: "Producto",
        destination: "Destino",
        orderedUnits: "UDS Pedidas",
        unidadesServidas: "UDS Servidas",
        purchasePrice: "Precio compra",
        salePrice: "Precio venta",
        factoryDeliveryDate: {
          name: "Fecha entrega fábrica",
          type: "datetime"
        },
        fechaLlegadaReal: {
          name: "Fecha entrega pedido",
          type: "datetime"
        },
        fechaRealCliente: {
          name: "Entrega real cliente",
          type: "datetime"
        },
        factoryLocation: "Origen fábrica",
        factoryName: "Fábrica"
      },
      data: [],
      year: this.$moment().year(),
      total: 0,
      completadas: 0,
      canceladas: 0
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    productionsPending() {
      let pending = this.total - (this.completadas + this.canceladas);
      return pending > 0 ? pending : 0;
    }
  },
  methods: {
    loadData(){
        this.fetchData();
        this.fetchSummary();
    },
    fetchData() {
      this.$axios.get("api/Productions/GetCompletada",{year:this.year}).then((response) => {
        this.data = response.data;
      });
      this.$axios.post("api/Productions/GetQuantity",{year:this.year}).then((response) => {
        this.total = response.data;
      });
    },
    fetchSummary() {
      // TODO: Cambiar las apis por las nuevas, que serán un POST y filtrarán por año.
      Promise.all([
        this.$axios.get(`api/Productions/GetQuantity`,{year:this.year}),
        this.$axios.post(`api/Productions/GetEntregadas`,{year:this.year}),
        this.$axios.post(`api/Productions/GetCancel`,{year:this.year})
      ]).then((values) => {
        this.total =  values[0].data;
        this.completadas =  values[1].data;
        this.canceladas  =  values[2].data;
      });
    }
  }
};
</script>
